const API_BASE = "https://openapi.nocodebackend.com";
const INSTANCE = "54678_smartlink_tags";
const TOKEN = import.meta.env.VITE_NOCODE_API_KEY;

const getHeaders = (hasBody = true) => {
  const headers = {
    'Authorization': `Bearer ${TOKEN}`
  };
  if (hasBody) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
};

export const auth = {
  // Login - Authenticate user using GET with query parameters
  login: async (username, password) => {
    try {
      // Use GET endpoint with query parameters for exact match
      const url = `${API_BASE}/read/admin_users?Instance=${INSTANCE}&username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(false)
      });
      
      if (!response.ok) {
        throw new Error("Network error. Please try again.");
      }

      const json = await response.json();
      
      console.log("Login response:", json); // Debug log
      
      // Check if we got data
      if (json.status === "success" && json.data && json.data.length > 0) {
        const user = json.data[0];
        
        // Check if user is active
        if (user.is_active !== 1) {
          throw new Error("Account is inactive. Contact administrator.");
        }
        
        // Store user session
        sessionStorage.setItem('admin_user', JSON.stringify({
          id: user.id,
          username: user.username,
          full_name: user.full_name,
          role: user.role
        }));
        
        return { success: true, user };
      } else {
        throw new Error("Invalid username or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },

  // Logout - Clear session
  logout: () => {
    sessionStorage.removeItem('admin_user');
  },

  // Check if user is logged in
  isAuthenticated: () => {
    return sessionStorage.getItem('admin_user') !== null;
  },

  // Get current user
  getCurrentUser: () => {
    const userJson = sessionStorage.getItem('admin_user');
    return userJson ? JSON.parse(userJson) : null;
  },

  // Create new admin user (for initial setup or admin management)
  createUser: async (userData) => {
    try {
      const response = await fetch(`${API_BASE}/create/admin_users?Instance=${INSTANCE}`, {
        method: 'POST',
        headers: getHeaders(true),
        body: JSON.stringify({
          username: userData.username,
          password: userData.password,
          full_name: userData.full_name,
          role: userData.role || 'admin',
          is_active: 1,
          created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
        })
      });
      
      const json = await response.json();
      return response.ok ? json : null;
    } catch (error) {
      console.error("Create user error:", error);
      throw error;
    }
  },

  // Get all admin users (for user management)
  getAllUsers: async () => {
    try {
      const url = `${API_BASE}/read/admin_users?Instance=${INSTANCE}&sort=id&order=desc`;
      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(false)
      });
      const json = await response.json();
      return Array.isArray(json.data) ? json.data : [];
    } catch (error) {
      console.error("Get users error:", error);
      return [];
    }
  }
};